import React from "react";
import {EditElementModalForm} from "../../EditElementModalForm";
import {Spinner} from "../../Spinner";
import {HELP_IMPORT_CSV_FROM_BUCC, LinkToArticle} from "../../help_center/LinkToArticle";
import {Switch} from "../../buttons/Swtich";
import { withTranslation } from 'react-i18next';


class ImportFromCSVModalFormComponent extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            importErrorText: this.props.importErrorText,
            saving: false,
            addUnSelectedItemsCheck: false,
            removeMissingSelectedItems: false,
            csvFile: null
        };

        this.handleOnChangeCSVFileInput = this.handleOnChangeCSVFileInput.bind(this);
        this.handleAddUnSelectedCampaignsCheckChange = this.handleAddUnSelectedCampaignsCheckChange.bind(this);
        this.handleRemoveMissingSelectedCampaigns = this.handleRemoveMissingSelectedCampaigns.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.importErrorText !== this.props.importErrorText) {
            this.setState({importErrorText: this.props.importErrorText});
        }
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            const { t } = this.props;
            return [<input type="submit" value={t('client.import_button')} className="btn -submit"/>];
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    handleAddUnSelectedCampaignsCheckChange(event) {
        const addUnSelectedItemsCheck = event.target.checked;
        this.setState({addUnSelectedItemsCheck: addUnSelectedItemsCheck});
    }

    handleRemoveMissingSelectedCampaigns(event) {
        const removeMissingSelectedItems = event.target.checked;
        this.setState({removeMissingSelectedItems: removeMissingSelectedItems});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: false});
        this.props.onModified(this.getDataToSubmit());

    }

    handleOnChangeCSVFileInput(e) {
        this.setState({
            csvFile: e.target.files[0]
        });
    };

    getDataToSubmit() {
        return {
            csvFile: this.state.csvFile,
            addUnSelectedItemsCheck: this.state.addUnSelectedItemsCheck,
            removeMissingSelectedItems: this.state.removeMissingSelectedItems
        };
    }

    renderFormFields() {
        return <div className="modal-section">
            <div className="form-row">
                <label><span title="Este campo es obligatorio">*</span>Archivo CSV<LinkToArticle
                    article={HELP_IMPORT_CSV_FROM_BUCC}/></label>
                <input type={"file"} id={"csvFileInput"} accept={".csv"} onChange={this.handleOnChangeCSVFileInput}/>
                <span className="input-validation">{this.state.importErrorText}</span>
            </div>
            <div className="switch-input d-flex align-items-center">
                <Switch
                    centered={true}
                    onChange={this.handleAddUnSelectedCampaignsCheckChange}
                    checked={this.state.addUnSelectedItemsCheck}
                    name="addUnSelectedItemsCheck"
                    messageToAlertUserIfChecked={null}
                />
                <div>Incluir automáticamente las campañas que no se encuentran seleccionadas</div>
            </div>
            <div className="switch-input d-flex align-items-center">
                <Switch
                    centered={true}
                    onChange={this.handleRemoveMissingSelectedCampaigns}
                    checked={this.state.removeMissingSelectedItems}
                    name="removeMissingSelectedItems"
                    messageToAlertUserIfChecked={null}
                />
                <div>{this.props.t('import_csv.remove_missing_campaigns')}</div>
            </div>
        </div>;
    }
}

export const ImportFromCSVModalForm = withTranslation()(ImportFromCSVModalFormComponent);
